import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../hooks'

export const Securities = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.securities"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="40. Securities / Futures / Options"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'40. Securities / Futures / Options'}
              direction={'vertical'}
              data={[
                { label: 'a. Insider trading', value: 'a' },
                { label: 'b. Market manipulation', value: 'b' },
                { label: 'c. Misappropriation', value: 'c' },
                { label: 'd. Unauthorized pooling', value: 'd' },
                { label: 'e. Wash trading', value: 'e' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
